import type { ErrorResponse } from "@/types/api/response/ErrorResponse";
import {
  CURRENT_PASSWORD_NOT_MATCH,
  MIN_VALUE,
  MIN_LENGTH,
  NOT_VALID,
  REQUIRED,
  USER_ALREADY_EXISTS,
  USER_INACTIVE,
  INVALID_HIT,
} from "./errors";

export default {
  build: (error: ErrorResponse) => {
    const field: string = error.fieldName;
    let data = null;
    if (typeof error.data !== "undefined") {
      data = error.data;
    }

    switch (error.message) {
      case REQUIRED:
        return `${field} is a required field.`;

      case NOT_VALID:
        return `Value of ${field} is invalid.`;

      case MIN_VALUE:
        return `${field} field requires a minimum value of ${data}.`;

      case MIN_LENGTH:
        return `${field} field requires a minimum length of ${data}.`;

      case USER_INACTIVE:
        return "The user is inactive.";

      case USER_ALREADY_EXISTS:
        return "The user already exists.";

      case CURRENT_PASSWORD_NOT_MATCH:
        return "The passwords do not match.";

      case INVALID_HIT:
        return "Invalid hit id";

      default:
        return error.message;
    }
  },
};
